import "./assets/styles.scss";
import HelloThere from "../../assets/imgs/hellothere.png";
import { FollowLink, followLinks } from "./assets/followLinks";

export default function About(): JSX.Element {
  const renderFollowLinks = () => {
    return followLinks.map((link: FollowLink) => (
      <li key={link.title} className="follow-link">
        <a title={link.title} rel="noreferrer" target="_blank" href={link.href}>
          <i className={link.icon}></i>
        </a>
      </li>
    ));
  };

  return (
    <section id="about" className="section about">
      <div className="about-left">
        <div className="about-intro">
          <span className="about-intro"> Hi, I'm Alex</span>
          <span className="about-intro secondary">Software Developer</span>
        </div>
        <div className="about-text">
          <p>
            I'm on a mission to master software engineering fundamentals and
            software development — from writing clean, efficient code to
            building intelligent systems that think and adapt.
          </p>
          <p>
            After years of unstructured learning, I now follow a structured
            curriculum with daily practice, real projects, and measurable
            progress.
          </p>
          <p>
            No more tutorial loops — just consistent, portfolio-ready builds.
          </p>
        </div>
      </div>
      <div className="about-right">
        <div className="about-img">
          <img src={HelloThere} alt="" />
        </div>
        <div className="follow">
          <ul className="follow-links">{renderFollowLinks()}</ul>
        </div>
      </div>
    </section>
  );
}
